import React from "react";
import { Menu, MenuItem, Box, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { IconGradient, SmallTextGradient } from "../Gradient";
import { getGlassCardStyles } from "../../utility/glassCard.utils";

type CreateMenuProps = {
  userId?: string;
  createMenuAnchor: HTMLElement | null;
  createMenuOpen: boolean;
  handleCreateMenuClose: () => void;
  setActive: (key: string) => void;
};

const CreateMenu: React.FC<CreateMenuProps> = ({
  userId,
  createMenuAnchor,
  createMenuOpen,
  handleCreateMenuClose,
  setActive,
}) => {
  return (
    <Menu
      anchorEl={createMenuAnchor}
      open={createMenuOpen}
      onClose={handleCreateMenuClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            elevation: 0,
            sx: (theme) => ({
              ...getGlassCardStyles(theme),
              mt: 1,
              p: 0,
              width: 'auto',
              maxWidth: '92vw',
              borderRadius: 3,
            }),
          }}
    >
      <MenuItem
        component={Link}
        to="/create-story"
        onClick={() => { handleCreateMenuClose(); setActive('create-story'); }}
        sx={(theme) => ({
          px: 3,
          py: 1.25,
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          transition: 'all 0.2s ease',
          borderRadius: 1,
          mx: 1,
          my: 0.5,
          position: 'relative',
          '&:hover': {
            backgroundColor: theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.05)'
              : 'rgba(0,0,0,0.04)',
            '& .menu-text-wrapper::after': {
              transform: 'scaleX(1)',
            },
          },
          '& .menu-text-wrapper': {
            position: 'relative',
            display: 'inline-block',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              right: 0,
              bottom: -2,
              height: '2px',
              background: theme.palette.mode === 'dark'
                ? 'linear-gradient(90deg, #ffffff 0%, #a5b4fc 100%)'
                : 'linear-gradient(90deg, #1e293b 0%, #3b82f6 100%)',
              borderRadius: '1px',
              transform: 'scaleX(0)',
              transformOrigin: 'left center',
              transition: 'transform 0.2s ease',
            },
          },
        })}
      >
        <IconGradient gradientVariant="default">
          <EditNoteOutlinedIcon fontSize="small" />
        </IconGradient>
        <Box className="menu-text-wrapper">
          <SmallTextGradient variant="body2" gradientVariant="default" sx={{ fontWeight: 600 }}>
            Create Story
          </SmallTextGradient>
        </Box>
      </MenuItem>
      {userId && (
        <>
          <Box sx={{ px: 1, py: 0.5 }}>
            <Divider
              sx={{
                borderColor: (theme) =>
                  theme.palette.mode === "dark"
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(0,0,0,0.08)",
              }}
            />
          </Box>
          <MenuItem
            component={Link}
            to="/my-stories?status=draft"
            onClick={() => { handleCreateMenuClose(); setActive('mystories'); }}
            sx={(theme) => ({
              px: 3,
              py: 1.25,
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              transition: 'all 0.2s ease',
              borderRadius: 1,
              mx: 1,
              my: 0.5,
              position: 'relative',
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark'
                  ? 'rgba(255,255,255,0.05)'
                  : 'rgba(0,0,0,0.04)',
                '& .menu-text-wrapper::after': {
                  transform: 'scaleX(1)',
                },
              },
              '& .menu-text-wrapper': {
                position: 'relative',
                display: 'inline-block',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  bottom: -2,
                  height: '2px',
                  background: theme.palette.mode === 'dark'
                    ? 'linear-gradient(90deg, #ffffff 0%, #a5b4fc 100%)'
                    : 'linear-gradient(90deg, #1e293b 0%, #3b82f6 100%)',
                  borderRadius: '1px',
                  transform: 'scaleX(0)',
                  transformOrigin: 'left center',
                  transition: 'transform 0.2s ease',
                },
              },
            })}
          >
            <IconGradient gradientVariant="default">
              <DescriptionOutlinedIcon fontSize="small" />
            </IconGradient>
            <Box className="menu-text-wrapper">
              <SmallTextGradient variant="body2" gradientVariant="default" sx={{ fontWeight: 600 }}>
                Drafts
              </SmallTextGradient>
            </Box>
          </MenuItem>
        </>
      )}
    </Menu>
  );
};

export default CreateMenu;


